export const serviceCategories = [
  {
    title: "Shodasha Samskaras (16 Sanskar Pujas)",
    description: "The sixteen essential purificatory rites (sanskaras) that mark the various stages of human life from conception to death",
    services: [
      {
        title: "Garbhadhana Sanskar",
        description: "Sacred ceremony performed before conception, seeking divine blessings for a healthy child and successful pregnancy.",
        link: "/services/garbhadhana"
      },
      {
        title: "Pumsavana Sanskar",
        description: "Ritual performed in the third month of pregnancy for the healthy development of the fetus and to invoke divine blessings.",
        link: "/services/pumsavana"
      },
      {
        title: "Simantonnayana Sanskar",
        description: "Ceremony performed during the seventh month of pregnancy for the mental and spiritual well-being of mother and child.",
        link: "/services/simantonnayana"
      },
      {
        title: "Jatakarma Sanskar",
        description: "Birth ceremony performed immediately after the birth of the child, welcoming the soul into the world.",
        link: "/services/jatakarma"
      },
      {
        title: "Namakarana Sanskar",
        description: "Naming ceremony performed on the 11th or 12th day after birth, choosing an auspicious name for the child.",
        link: "/services/namakarana"
      },
      {
        title: "Nishkramana Sanskar",
        description: "First outing ceremony when the baby is taken to the temple, usually in the fourth month after birth.",
        link: "/services/nishkramana"
      },
      {
        title: "Annaprasana Sanskar",
        description: "First feeding ceremony where solid food is introduced to the child, typically performed in the sixth month.",
        link: "/services/annaprasana"
      },
      {
        title: "Chudakarana Sanskar",
        description: "First hair-cutting ceremony (Mundan) performed between the first and third year to remove the birth hair.",
        link: "/services/chudakarana"
      },
      {
        title: "Karnavedha Sanskar",
        description: "Ear-piercing ceremony performed for both spiritual and health benefits, typically in the third or fifth year.",
        link: "/services/karnavedha"
      },
      {
        title: "Vidyarambha Sanskar",
        description: "Ceremony marking the beginning of formal education, where the child learns to write their first letters.",
        link: "/services/vidyarambha"
      },
      {
        title: "Upanayana Sanskar",
        description: "Sacred thread ceremony marking the beginning of the Brahmacharya phase and formal Vedic education.",
        link: "/services/upanayana"
      },
      {
        title: "Vedarambha Sanskar",
        description: "Ceremony marking the commencement of Vedic studies after the sacred thread ceremony.",
        link: "/services/vedarambha"
      },
      {
        title: "Keshanta Sanskar",
        description: "Coming of age ceremony for boys, marking the transition from childhood to youth.",
        link: "/services/keshanta"
      },
      {
        title: "Samavartana Sanskar",
        description: "Graduation ceremony marking the completion of formal education and return from Guru's ashram.",
        link: "/services/samavartana"
      },
      {
        title: "Vivaha Sanskar",
        description: "Traditional wedding ceremony marking the beginning of Grihastha (household) life.",
        link: "/services/vivaha"
      },
      {
        title: "Antyeshti Sanskar",
        description: "Final rites performed after death, ensuring the soul's peaceful journey to the next world.",
        link: "/services/antyeshti"
      }
    ]
  },
  {
    title: "Daily Rituals & Pujas",
    description: "Experience the divine through our daily ceremonies and traditional rituals",
    services: [
      {
        title: "Morning Abhishekam",
        description: "Sacred bathing ritual of the deities performed early morning with milk, curd, honey, and other sacred items.",
        link: "/services/abhishekam"
      },
      {
        title: "Nityarchana",
        description: "Daily worship service including flower offerings, mantras, and prasad distribution.",
        link: "/services/nityarchana"
      },
      {
        title: "Evening Aarti",
        description: "Traditional lamp ceremony with sacred chants and musical accompaniment.",
        link: "/services/aarti"
      },
      {
        title: "Pushpanjali",
        description: "Sacred flower offering ceremony performed during specific times.",
        link: "/services/pushpanjali"
      },
      {
        title: "Sankalpam",
        description: "Ritual declaration of intent before performing any major puja.",
        link: "/services/sankalpam"
      },
      {
        title: "Morning Surya Namaskar",
        description: "Traditional sun salutation ritual with Vedic mantras and offerings.",
        link: "/services/surya-namaskar"
      },
      {
        title: "Tulsi Puja",
        description: "Daily worship of the sacred Tulsi plant with special mantras and offerings.",
        link: "/services/tulsi-puja"
      },
      {
        title: "Bhog Offering",
        description: "Sacred food offering to the deities prepared with pure ingredients.",
        link: "/services/bhog"
      }
    ]
  },
  {
    title: "Homam & Yagnas",
    description: "Sacred fire ceremonies for specific purposes and divine blessings",
    services: [
      {
        title: "Ganapati Homam",
        description: "Fire ceremony dedicated to Lord Ganesha for removing obstacles and new beginnings.",
        link: "/services/ganapati-homam"
      },
      {
        title: "Navagraha Homam",
        description: "Sacred fire ritual to appease the nine planetary deities for cosmic harmony.",
        link: "/services/navagraha-homam"
      },
      {
        title: "Rudra Homam",
        description: "Powerful fire ceremony dedicated to Lord Shiva for transformation and blessing.",
        link: "/services/rudra-homam"
      },
      {
        title: "Lakshmi Homam",
        description: "Fire ritual for prosperity and abundance, dedicated to Goddess Lakshmi.",
        link: "/services/lakshmi-homam"
      },
      {
        title: "Ayush Homam",
        description: "Sacred fire ceremony for longevity, health and well-being.",
        link: "/services/ayush-homam"
      },
      {
        title: "Sudarshana Homam",
        description: "Protective fire ritual invoking the divine chakra of Lord Vishnu.",
        link: "/services/sudarshana-homam"
      }
    ]
  },
  {
    title: "Festival Celebrations",
    description: "Join us in celebrating major Hindu festivals with traditional rituals and ceremonies",
    services: [
      {
        title: "Diwali Celebrations",
        description: "Grand celebration of the festival of lights with special pujas and cultural programs.",
        link: "/services/diwali"
      },
      {
        title: "Navaratri Festival",
        description: "Nine nights of goddess worship with special rituals and cultural performances.",
        link: "/services/navaratri"
      },
      {
        title: "Krishna Janmashtami",
        description: "Celebration of Lord Krishna's birth with midnight arati and special ceremonies.",
        link: "/services/janmashtami"
      },
      {
        title: "Maha Shivaratri",
        description: "Night-long worship of Lord Shiva with special abhishekams and rudrabhishekam.",
        link: "/services/shivaratri"
      },
      {
        title: "Ganesh Chaturthi",
        description: "Ten-day celebration of Lord Ganesha with daily rituals and cultural events.",
        link: "/services/ganesh-chaturthi"
      }
    ]
  },
  {
    title: "Graha Shanti Pujas",
    description: "Vedic ceremonies to harmonize planetary influences and bring peace and prosperity",
    services: [
      {
        title: "Ketu Shanti Puja",
        description: "Special rituals to mitigate the effects of Ketu and gain spiritual insight.",
        link: "/services/ketu-shanti"
      },
      {
        title: "Rahu Shanti Puja",
        description: "Sacred ceremony to pacify Rahu and overcome obstacles in life.",
        link: "/services/rahu-shanti"
      },
      {
        title: "Shani Shanti Puja",
        description: "Rituals to appease Saturn and gain strength during challenging times.",
        link: "/services/shani-shanti"
      },
      {
        title: "Mangal Dosha Nivaran",
        description: "Special puja to mitigate the effects of Mars and remove marriage obstacles.",
        link: "/services/mangal-dosha"
      },
      {
        title: "Budh Graha Shanti",
        description: "Ceremony for Mercury to improve communication and business prospects.",
        link: "/services/budh-shanti"
      }
    ]
  },
  {
    title: "Healing & Wellness Rituals",
    description: "Ancient Vedic ceremonies for physical, mental, and spiritual well-being",
    services: [
      {
        title: "Mrityunjaya Homa",
        description: "Powerful ritual for overcoming health challenges and ensuring longevity.",
        link: "/services/mrityunjaya"
      },
      {
        title: "Dhanvantari Puja",
        description: "Sacred ceremony dedicated to the god of Ayurveda for healing and health.",
        link: "/services/dhanvantari"
      },
      {
        title: "Arogya Puja",
        description: "Special ritual for maintaining good health and preventing illnesses.",
        link: "/services/arogya"
      },
      {
        title: "Sarpa Dosha Nivaran",
        description: "Ritual to remove negative effects of snake doshas and related health issues.",
        link: "/services/sarpa-dosha"
      }
    ]
  },
  {
    title: "Example Services",
    description: "Testing and example services for payment verification",
    services: [
      {
        title: "Example Service",
        description: "An example test service priced at ₹1 for payment flow verification and demonstration.",
        link: "/services/example"
      }
    ]
  }
];

// Service prices
export const servicePrices = {
  "Garbhadhana Sanskar": 5100,
  "Pumsavana Sanskar": 3100,
  "Simantonnayana Sanskar": 4100,
  "Jatakarma Sanskar": 5100,
  "Namakarana Sanskar": 3100,
  "Nishkramana Sanskar": 2100,
  "Annaprasana Sanskar": 3100,
  "Chudakarana Sanskar": 4100,
  "Karnavedha Sanskar": 2100,
  "Vidyarambha Sanskar": 3100,
  "Upanayana Sanskar": 7100,
  "Vedarambha Sanskar": 5100,
  "Keshanta Sanskar": 3100,
  "Samavartana Sanskar": 5100,
  "Vivaha Sanskar": 21100,
  "Antyeshti Sanskar": 11100,
  "Morning Abhishekam": 1100,
  "Nityarchana": 901,
  "Evening Aarti": 901,
  "Pushpanjali": 901,
  "Sankalpam": 901,
  "Morning Surya Namaskar": 1100,
  "Tulsi Puja": 901,
  "Bhog Offering": 1501,
  "Ganapati Homam": 5100,
  "Navagraha Homam": 11100,
  "Rudra Homam": 7100,
  "Lakshmi Homam": 5100,
  "Ayush Homam": 4100,
  "Sudarshana Homam": 5100,
  "Diwali Celebrations": 11100,
  "Navaratri Festival": 21100,
  "Krishna Janmashtami": 5100,
  "Maha Shivaratri": 7100,
  "Ganesh Chaturthi": 11100,
  "Ketu Shanti Puja": 4100,
  "Rahu Shanti Puja": 4100,
  "Shani Shanti Puja": 4100,
  "Mangal Dosha Nivaran": 5100,
  "Budh Graha Shanti": 4100,
  "Mrityunjaya Homa": 7100,
  "Dhanvantari Puja": 5100,
  "Arogya Puja": 3100,
  "Sarpa Dosha Nivaran": 5100,
  "Example Service": 1
}; 